import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const TemplatesView = lazy(async () => {
  const m = await import("@/features/templates/components/templates-view");
  return { default: m.TemplatesView };
});

export interface TemplatesSearch {
  /** Deep-link: open the "new template" dialog. */
  new?: string;
}

export const templatesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/templates",
  validateSearch: (search: Record<string, unknown>): TemplatesSearch => ({
    new: search.new === "template" ? "template" : undefined,
  }),
  component: () => (
    <Suspense fallback={null}>
      <TemplatesView />
    </Suspense>
  ),
});
